import React from "react";
import { Button, Stack } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { playPronunciation } from "../../flashcardUtils";

function PracticeActions({
  isPracticeDone,
  practicePhase,
  practiceFlipped,
  practiceCard,
  practiceAnswer,
  practiceResult,
  practiceMeta,
  isReviewingCard,
  onClose,
  onResetPractice,
  onAdvancePractice,
  onPracticeRecall,
  onCheckPracticeAnswer,
  onGetAdvanceLabel,
  onSetPracticeFlipped,
}) {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.25}
      justifyContent="center"
      sx={{
        maxWidth: 980,
        width: "100%",
        mx: "auto",
        py: { md: 0.75 },
        px: { md: 1 },
        borderRadius: { md: "18px" },
        bgcolor: { md: "rgba(255, 254, 253, 0.78)" },
        backdropFilter: { md: "blur(10px)" },
      }}
    >
      {isPracticeDone ? (
        <>
          <Button
            onClick={onResetPractice}
            variant="outlined"
            sx={{ borderRadius: "999px", borderColor: "#d7eaf5", px: 3 }}
          >
            Practice again
          </Button>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{ borderRadius: "999px", bgcolor: "#6d4aff", px: 3, "&:hover": { bgcolor: "#5a3ee0" } }}
          >
            Back to deck
          </Button>
        </>
      ) : practicePhase === "learn" ? (
        <>
          <Button
            onClick={() =>
              playPronunciation(practiceCard?.front, [
                ...(practiceCard?.audioUrls || []),
                practiceCard?.audioUrl,
              ])
            }
            disabled={!practiceCard}
            variant="outlined"
            startIcon={<VolumeUpIcon />}
            sx={{ borderRadius: "999px", borderColor: "#d7eaf5", px: 3 }}
          >
            Listen
          </Button>
          <Button
            onClick={onAdvancePractice}
            disabled={!practiceCard}
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{ borderRadius: "999px", bgcolor: practiceMeta.accent, px: 3, "&:hover": { bgcolor: practiceMeta.accent } }}
          >
            {onGetAdvanceLabel()}
          </Button>
        </>
      ) : practicePhase === "recall" ? (
        practiceFlipped ? (
          <>
            <Button
              onClick={() => onPracticeRecall(false)}
              disabled={!practiceCard || isReviewingCard}
              variant="outlined"
              sx={{ borderRadius: "999px", borderColor: "#d7eaf5", px: 3 }}
            >
              Need review
            </Button>
            <Button
              onClick={() => onPracticeRecall(true)}
              disabled={!practiceCard || isReviewingCard}
              variant="contained"
              startIcon={<CheckCircleIcon />}
              sx={{ borderRadius: "999px", bgcolor: "#35c759", px: 3, "&:hover": { bgcolor: "#2fb44f" } }}
            >
              I knew it
            </Button>
          </>
        ) : (
          <Button
            onClick={() => onSetPracticeFlipped(true)}
            disabled={!practiceCard}
            variant="contained"
            sx={{ borderRadius: "999px", bgcolor: practiceMeta.accent, px: 3, "&:hover": { bgcolor: practiceMeta.accent } }}
          >
            Reveal answer
          </Button>
        )
      ) : (
        <Button
          onClick={practiceResult === null ? onCheckPracticeAnswer : onAdvancePractice}
          disabled={!practiceCard || (practiceResult === null && !practiceAnswer.trim())}
          variant="contained"
          endIcon={practiceResult === null ? null : <ArrowForwardIcon />}
          sx={{ borderRadius: "999px", bgcolor: practiceMeta.accent, px: 3, "&:hover": { bgcolor: practiceMeta.accent } }}
        >
          {practiceResult === null ? "Check answer" : onGetAdvanceLabel()}
        </Button>
      )}
    </Stack>
  );
}

export default PracticeActions;
